export default Object.freeze({
  Json: 1,
  Text: 2,
  Csv: 3,
  Xml: 4,
  Parquet: 5,
});
